import React, {useCallback, useMemo, useRef} from 'react'
import {useFiltersForm} from 'hooks/useFiltersForm'
import useShowOverlay from 'hooks/useShowOverlay/useShowOverlay'
import {OverlayType} from 'modules/overlay/types'

import {Icon} from '@vio/atlas/Icon'
import {Pill} from '@vio/atlas/Pill'

import {StarRatingBottomSheet} from './StarRatingBottomSheet'

const filterKeys = ['starRatings']
const elementName = 'quickFilterstarRating'
const noQuickFilterValues: string[] = []

interface Props {
  quickFilterValues?: string[]
  isActive?: boolean
  isQuickFilter?: boolean
}
export const StarRatingPill: React.FC<Props> = ({
  quickFilterValues = noQuickFilterValues,
  isActive = false,
  isQuickFilter = false
}) => {
  const showOverlay = useShowOverlay()
  const buttonRef = useRef<HTMLButtonElement>(null)

  const {getAppliedStarsLabel, submitFilters} = useFiltersForm(
    filterKeys,
    elementName
  )

  const pillLabel = useMemo(
    () =>
      isQuickFilter
        ? getAppliedStarsLabel(quickFilterValues)
        : getAppliedStarsLabel(),
    [isQuickFilter, quickFilterValues, getAppliedStarsLabel]
  )

  const handlePillClick = useCallback(() => {
    if (isActive) buttonRef.current?.blur()

    const updatedFilters = {
      starRatings: isActive ? undefined : quickFilterValues
    }

    if (!isQuickFilter) {
      showOverlay({
        type: OverlayType.StarRatingsFilter
      })
    } else {
      submitFilters(updatedFilters)
    }
  }, [isActive, submitFilters, quickFilterValues, isQuickFilter, showOverlay])

  if (isQuickFilter && isActive) return null

  return (
    <>
      <Pill
        dataId={
          isQuickFilter
            ? `${quickFilterValues.join('to')}StarFilter`
            : 'starRatingFilter'
        }
        onClick={handlePillClick}
        isSelected={isActive}
        iconStart={<Icon name="Star" />}
        iconEnd={isActive && isQuickFilter && <Icon name={'Close'} />}
        showArrow={!isQuickFilter}
      >
        {pillLabel}
      </Pill>
      <StarRatingBottomSheet />
    </>
  )
}
